/* RoboHelpRenderer.js */

"use strict";
const iframe = require("iframe");

class RoboHelpRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("robo-help-holder");

        this._helpPage = undefined;

        this._initialize();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._helpPage.iframe.addEventListener("load", this._attachIframeStyles.bind(this));
    }

    _unregisterListeners() {
        this._helpPage.iframe.removeEventListener("load", this._attachIframeStyles);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        let promArr = [Promise.resolve()];

        return Promise.all(promArr).then(() => {
            //TODO set all class members to undefined here
            this._model = undefined;
            this._helpPage.remove();
            this._helpPage = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
        });
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    //TODO Private Render Methods here
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _initialize() {
        const currentSection = this.model.getCurrentSection();
        this._helpPage = iframe({
            container: this._rootElem,
            src: "/help_html/index.htm",
            sandboxAttributes: [
                "allow-scripts",
                "allow-same-origin",
                "allow-modals",
                "allow-popups",
            ],
        });
        if (currentSection && currentSection !== "#") {
            this._helpPage.iframe.src = "/help_html/index.htm#t=" + currentSection;
        }
        this._registerListeners();
    }

    _attachIframeStyles() {
        const iframeHead = this._helpPage.iframe.contentDocument
                .getElementsByTagName("head")
                .item(0),
            iframeBody = this._helpPage.iframe.contentDocument.body;

        // Temporarily hide the functionbar while our stylesheet loads to avoid
        // a visible flash as the browser swaps from the template's PNG icons to
        // our injected SVG icons.
        const hideStyle = document.createElement("style");
        hideStyle.textContent = "div.functionbar { visibility: hidden; }";
        iframeHead.appendChild(hideStyle);

        const link = document.createElement("link");
        link.setAttribute("rel", "stylesheet");
        link.setAttribute("type", "text/css");
        link.setAttribute("href", "/styles/main.css");
        link.addEventListener("load", () => hideStyle.remove());
        iframeBody.classList.add("robo-help-view-gl");
        iframeHead.appendChild(link);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = RoboHelpRenderer;
